// select option if not selected and deselect if already selected (if deselect parameter is set to true)
const updateSelectedOptions = (
  selectedOptionId,
  selectedOptions,
  allOptions,
  deselect = true,
  allowNew = false
) => {
  let selectedOption = allOptions.find((option) => option.id === selectedOptionId) ?? null;
  if (!selectedOption && allowNew) {
    selectedOption = { id: selectedOptionId, value: selectedOptionId, isNew: true };
  }

  const selectedOptionsIds = selectedOptions?.map((option) => option.id);

  let newSelectedOptionsList = [];

  if (selectedOptionsIds.includes(selectedOptionId)) {
    newSelectedOptionsList = deselect
      ? selectedOptions.filter((option) => option.id !== selectedOptionId)
      : selectedOptions;
  } else {
    newSelectedOptionsList = [...selectedOptions, selectedOption];
  }

  return newSelectedOptionsList;
};

const dropdownUtil = {
  updateSelectedOptions
};

export default dropdownUtil;
